import React from "react";
import {
  Typography,
  List,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { ExtractedContract } from "../../../types/contract";
import { GradientBorderBox } from "./shared";

interface ContractListProps {
  paginatedContracts: ExtractedContract[];
  selectedContract: ExtractedContract | null;
  isTrashView: boolean;
  handleSelectItem: (contract: ExtractedContract) => void;
}

const ContractList: React.FC<ContractListProps> = ({
  paginatedContracts,
  selectedContract,
  isTrashView,
  handleSelectItem,
}) => {
  return (
    <GradientBorderBox sx={{ maxHeight: "70vh", overflow: "auto" }}>
      <List dense sx={{ padding: 0 }}>
        {paginatedContracts.map((contract) => (
          <ListItemButton
            key={contract.id}
            selected={selectedContract?.id === contract.id}
            onClick={() => handleSelectItem(contract)}
            sx={{
              "&.Mui-selected": {
                backgroundColor: "rgba(235, 217, 255, 0.7)",
                "&:hover": {
                  backgroundColor: "rgba(235, 217, 255, 1)",
                },
              },
              "&:hover": {
                backgroundColor: "rgba(235, 217, 255, 0.3)",
              },
            }}
          >
            <ListItemText
              primary={`${contract.property_name} ${contract.room_name}`}
              secondary={
                isTrashView
                  ? (() => {
                      if (!contract.deleted_at) return "削除日不明";
                      const deletionDate = new Date(contract.deleted_at);
                      const expiryDate = new Date(
                        deletionDate.setDate(deletionDate.getDate() + 30)
                      );
                      const now = new Date();
                      const diffMillis =
                        expiryDate.getTime() - now.getTime();
                                                const diffDays = diffMillis / (1000 * 60 * 60 * 24);

                                                let deleteMessage: string;
                                                 if (diffDays < 1) {
                                                   deleteMessage = "完全削除まであと1日未満";
                                                 } else {
                                                   const days = Math.floor(diffDays);
                                                   deleteMessage = `完全削除まであと${days}日`;
                                                 }                            return (
                        <React.Fragment>
                          <Typography component="span" variant="body2" color="text.primary" display="block">
                            {contract.lessee_name}
                          </Typography>
                          <Typography component="span" variant="body2" color="text.secondary" display="block">
                            ({deleteMessage})
                          </Typography>
                        </React.Fragment>
                      );
                     })()
                  : contract.lessee_name
              }
            />
          </ListItemButton>
        ))}
      </List>
    </GradientBorderBox>
  );
};

export default ContractList;
